import Helper from '@ember/component/helper';

import { UsingTouchLayout } from '@kmccullough/using-touch-layout';

import { service } from '@ember/service';

export default class AccessibleLayoutsHelper extends Helper {
  @service ssr;

  mtl;

  compute(params, { nonTouchActiveClass, touchActiveClass }) {
    if (this.ssr.isSsr) {
      return;
    }
    if (this.isInitialized) {
      this.mtl.setClasses(nonTouchActiveClass, touchActiveClass);
    } else {
      this.isInitialized = true;
      this.mtl = new UsingTouchLayout({
        nonTouchActiveClass,
        touchActiveClass,
      });
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);
    if (this.ssr.isSsr) {
      return;
    }
    this.mtl.destroy();
  }
}
